module.exports = __webpack_public_path__ + "static/media/separator.2cfeb1c9.svg";